import api from './api';

// MIGRATION: Removed independent agent routing logic
// All agents now use unified /payment-links endpoints
// Backend handles role-based filtering automatically

export const paymentLinksService = {
  // Get all payment links
  getAll: async () => {
    const response = await api.get('/payment-links');
    return response.data;
  },

  // Create payment link
  create: async (paymentLinkData) => {
    const response = await api.post('/payment-links', paymentLinkData);
    return response.data;
  },

  // Get specific payment link
  get: async (id) => {
    const response = await api.get(`/payment-links/${id}`);
    return response.data;
  },

  // Update payment link
  update: async (id, paymentLinkData) => {
    const response = await api.put(`/payment-links/${id}`, paymentLinkData);
    return response.data;
  },

  // Cancel payment link
  cancel: async (id) => {
    const response = await api.delete(`/payment-links/${id}`);
    return response.data;
  },

  // Resend payment link email
  resend: async (id) => {
    const response = await api.post(`/payment-links/${id}/resend`);
    return response.data;
  },

  // Get payment link statistics
  getStats: async () => {
    const response = await api.get('/payment-links/stats');
    return response.data;
  },

  // Force update expired links
  updateExpired: async () => {
    const response = await api.post('/payment-links/update-expired');
    return response.data;
  },

  // Send manual reminder for payment link
  sendReminder: async (id) => {
    const response = await api.post(`/payment-links/${id}/send-reminder`);
    return response.data;
  },

  // Get payment links that need reminders
  getRemindersDue: async () => {
    const response = await api.get('/payment-links/reminders-due');
    return response.data;
  }
};

// Public payment links service (no auth required)
export const publicPaymentLinksService = {
  // Get payment link details by token
  getByToken: async (token) => {
    const response = await api.get(`/public/payment-links/${token}`);
    return response.data;
  },

  // Submit payment for payment link
  submitPayment: async (token, paymentData) => {
    const response = await api.post(`/public/payment-links/${token}/submit`, paymentData);
    return response.data;
  }
};
